module.exports = __webpack_public_path__ + "img/antenne-stmk-btn.2d52a77b.svg";